/**
 * Job view stays mounted across job-id changes (same route component).
 * Do not render job-scoped editors until the loaded job matches the route,
 * otherwise assignee notes / tags from the previous job can be saved onto
 * the newly selected job.
 */
export function isJobViewDataReady<TJob extends { id: string }>(
  job: TJob | null | undefined,
  jobId: string
): job is TJob {
  return Boolean(job && String(job.id) === String(jobId));
}
